module.exports = __webpack_public_path__ + "static/cstoreslider-17-min-96a2d48dfe826d3d0ada710384742528.jpg";